import { Heading, Box, Text } from '@chakra-ui/react';
import { getTranslation } from '../utils/translations';
import { i18n } from '@shared';
import { useSurveyContext } from '../context/SurveyContext';
import { useTranslation } from 'react-i18next';

export default function AfterSubmitPage() {
	const { t } = useTranslation();
	const { survey } = useSurveyContext();
	const surveyHasAfterParagraph = getTranslation(survey.translations, 'surveys.afterParagraph', i18n.resolvedLanguage || 'fi', false) !== '';

	return (
		<>
			{getTranslation(survey.translations, 'surveys.title', i18n.resolvedLanguage || 'fi', false) !== '' ? (
				<Heading textAlign={'center'} color="black" className="tav-survey-after-submit-page-heading">
					{getTranslation(survey.translations, 'surveys.title', i18n.resolvedLanguage || 'fi')}
				</Heading>
			) : null}
			{surveyHasAfterParagraph ? (
				<Box
					className="tav-survey-after-paragraph"
					marginTop={4}
					dangerouslySetInnerHTML={{ __html: getTranslation(survey.translations, 'surveys.afterParagraph', i18n.resolvedLanguage || 'fi') }}
				/>
			) : (
				<Text className="tav-survey-answer-sent" marginTop="4" textAlign={'center'}>
					{t('general.answer_sent')}
				</Text>
			)}

			<Box marginTop="auto"></Box>
		</>
	);
}
